import { render } from "./ProviderDashboard.vue?vue&type=template&id=7d3bfb44"
import script from "./ProviderDashboard.vue?vue&type=script&lang=js"
export * from "./ProviderDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__